import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FpFooterComponent } from './common/fp-footer/fp-footer.component';
import { FpNavbarComponent } from './common/fp-navbar/fp-navbar.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle'; 
import { ToggleService } from '../../../template-components/header/toggle.service';

@Component({
  selector: 'app-front-pages',
  standalone: true,
  imports: [
    RouterOutlet,
    FpNavbarComponent,
    FpFooterComponent,
    MatSlideToggleModule // <-- Add here
  ],
  templateUrl: './front-pages.component.html',
  styleUrls: ['./front-pages.component.scss']
})
export class FrontPagesComponent {

  constructor(public toggleService: ToggleService) {}

  ngOnInit(): void {
    this.toggleService.initializeTheme();
  }

  toggleTheme() {
    this.toggleService.toggleTheme();
  }

  toggleDirection() {
    this.toggleService.toggleDirection();
  }
}
